import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  TemplateRef,
  AfterViewInit,
  Input,
  ElementRef
} from '@angular/core'
import { MatTabChangeEvent } from '@angular/material'
import { OutputComponent } from 'app/crm/output/output.component'
import { StoreService } from 'app/service/store.service'
import { AeSummaryComponent } from 'app/crm/ae-summary/ae-summary.component'
import { CpmService } from '../../service/cpm.service'
import { Subscription } from 'rxjs/Subscription'
import { ContactComponent } from '../contact/contact.component'
import { FormControl } from '@angular/forms'
import { BsModalRef, BsModalService } from 'ngx-bootstrap'
import { AuthorizeService } from '../../service/authorize.service'
import { ToastrService } from '../../../../node_modules/ngx-toastr'
import { CrmScreenInputComponent } from '../crm-screen-input/crm-screen-input.component'
import { Router } from '@angular/router'

@Component({
  selector: 'app-crm-screen',
  templateUrl: './crm-screen.component.html',
  styleUrls: ['./crm-screen.component.scss']
})
export class CrmScreenComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(ContactComponent) contactComponent: ContactComponent
  @ViewChild(CrmScreenInputComponent) crmScreenInput: CrmScreenInputComponent
  @ViewChild(OutputComponent) outputComponent: OutputComponent
  @ViewChild(AeSummaryComponent) aeSummaryComponent: AeSummaryComponent
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  message = 'Do you want to leave this page without saving data?'
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  selected = 0
  displayCancelAction = false
  constructor(
    private store: StoreService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private router: Router
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
  }

  onTabClick(event: MatTabChangeEvent) {
    if (this.selected !== 2 && event.index === 2) {
      this.outputComponent.reInitialTable();
    }
    
    this.selected = event.index
    if (this.selected === 0) {
      this.contactComponent.reInitialTable();
    } else if (this.selected === 1) {
      this.crmScreenInput.reInitialTable();
    } else if (this.selected === 3) {
      this.aeSummaryComponent.reInitialTable();
    }
    if (this.selected !== 2) {
      this.store.setOutputCaseByIdBehavior(null)
    }
    if (this.selected !== 1 && this.displayCancelAction) {
      this.openModal(this.templateSaved)
    }
  }

  ngOnDestroy(): void {
    this.store.setOutputCaseByIdBehavior(null)
  }

  setSelectedIndex(event) {
    this.selected = event
  }

  display(data) {
    this.displayCancelAction = data
    this.store.setInputOpenBehavior(this.displayCancelAction)
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }

  closeModal() {
    this.modalRef.hide()
    this.displayCancelAction = false
    this.crmScreenInput.onFinished({ message: 'Cancel action.', status: 'WARNNING' })
  }
  goBack() {
    const close = this.modalRef.hide()
    const back = this.setSelectedIndex(1)
    return (close && back)
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/crm-screen/crm-screen.component.ts